//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import JobSeeker from './JobSeeker';
import JobsList from './JobsList';
import EditJob from '../EditJob';

export default {
  name: 'JobsManagement',
  components: { JobSeeker, JobsList, EditJob },
  computed: {
    ...mapGetters('user', ['userStatus']),
    isEditJob() {
      return !!this.$route.query.jobPositionId && !!this.$route.query.isEdit;
    },
    isSeeker() {
      return !!this.$route.query.jobPositionId;
    },
    jobPositionId() {
      return this.$route.query.jobPositionId;
    },
  },
};
